import { useEffect } from 'react';

import { useQueryClient } from '@tanstack/react-query';

import { checkForStatusPageIncident } from 'shared/lib/statusPage/common';
import { useIncidentDialog } from 'shared/lib/statusPage/useIncidentDialog';

export const IncidentDialog = () => {
  const queryClient = useQueryClient();
  const { showIncidentDialog } = useIncidentDialog();

  useEffect(() => {
    const handleError = async (error: Error) => {
      const incident = await checkForStatusPageIncident({ queryClient, error });

      if (incident) {
        showIncidentDialog(incident);
      }
    };

    const unsubscribeQuery = queryClient.getQueryCache().subscribe((event) => {
      if (event.type === 'updated' && event.action.type === 'error') {
        handleError(event.action.error);
      }
    });

    const unsubscribeMutation = queryClient.getMutationCache().subscribe((event) => {
      if (event.type === 'updated' && event.action.type === 'error') {
        handleError(event.action.error);
      }
    });

    return () => {
      unsubscribeQuery();
      unsubscribeMutation();
    };
  }, [queryClient, showIncidentDialog]);

  return null;
};
